import { React, useState, useEffect } from 'react';
import Nav from './nav';
import './tabs.css';
import Card from './card';
import Transcript from './bulletin';
import { Form, useNavigate } from 'react-router-dom';
import Receipt from './receipt.js';

function Tab() {
  const [activeTab, setActiveTab] = useState('Tab1');
  const navigate = useNavigate();

  useEffect(() => {
    switch (activeTab) {
      case 'Tab1':
        document.title = 'U.M.A';
        break;
      case 'Tab2':
        document.title = 'Transcript';
        break;
      case 'Tab3':
        document.title = 'Receipt';
        break;
      default:
        document.title = 'Admin';
    }
  }, [activeTab]);

  const enter = () => {
    navigate('/gen')
}
  return (
    <div className="tab-page">
      <Nav/>
      <br/>
      <br/>
      <div className="tab-container">
        <div className="tabs">
          <button
            className={activeTab === 'Tab1' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab1')}
          >
            Carte Etudiant
          </button>
          <button
            className={activeTab === 'Tab2' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab2')}
          >
            Bulletin Academique
          </button>
          <button
            className={activeTab === 'Tab3' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('Tab3')}
          >
            Reçu de Paiement
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'Tab1' && <div className="content"><Card/></div>}
          {activeTab === 'Tab2' && <div className="content"><Transcript/></div>}
          {activeTab === 'Tab3' && <div className="content"><Receipt/></div>}
        </div>
      </div>
      <footer>U.M.A © All Rights Reserved.</footer>
    </div>
  );
}

export default Tab;
